import { useTranslation } from 'react-i18next';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AppController from '@jwp/ott-common/src/controllers/AppController';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { shallow } from '@jwp/ott-common/src/utils/compare';

export const useMenuItems = () => {
  const appController = getModule(AppController);
  const {
    i18n: { language },
  } = useTranslation();
  const { isLoggedIn, hasSubscription } = useAccountStore(({ user, subscription }) => ({ isLoggedIn: !!user, hasSubscription: !!subscription }), shallow);

  return useQuery({
    queryKey: ['menu-items', language, isLoggedIn, hasSubscription],
    queryFn: () => appController.getMenuItems({ language, isLoggedIn, hasSubscription }),
    placeholderData: keepPreviousData,
  });
};
